import "can/model/";

function modifiedDataSource( data ) {
    "use strict";
    var permissions = [];
    
    // Remove "PERM_IS_ELEVATED_USER" from the permission collection
    _.forEach( data, function(value){
        if( value.name == 'PERM_IS_ELEVATED_USER' ) return;
        
        permissions.push(value);
    })
    
    return permissions;
}

export default can.Model.extend({
    findAll: function() {
        "use strict";
        return can.ajax({
            url: "/api/v2/permissions",
            type: "GET",
            dataType: "json"
        });
    },

    parseModels: function( data ) {
        "use strict";
        return modifiedDataSource( data );
    }
}, {});